import { Button, Input, showToast } from '@attentive-platform/stem-ui';
import { useState } from 'react';
import { FormContainer } from '../../../styled';
import { isValidEmail } from '../../../Utils/HelperFunctions';
import { useBlockUser } from '../../../Utils/services';

export const BlockUser = () => {
  const [email, setEmail] = useState('');
  const { mutate, loading } = useBlockUser();

  const onSubmitHandler = () => {
    const data = { email };
    mutate(
      { data },
      {
        onSuccess: () => {
          showToast('User blocked successfully', 'success');
          setEmail('');
        },
        onError: error => {
          showToast(error, 'error');
        }
      }
    );
  };

  return (
    <FormContainer>
        <Input
          label='User email'
          type='email'
          name='bu-page-email'
          fullWidth
          placeholder='Enter user email address'
          value={email}
          onChange={e => setEmail(e.target.value)}
          required
          className='mb-2'
        />
      <div className='flex justify-end'>
        <Button
          disabled={!email || !isValidEmail(email)}
          color='primary'
          size='medium'
          variant='contained'
          onClick={onSubmitHandler}
          loading={loading}
          className='text-base'>
          Block user
        </Button>
      </div>
    </FormContainer>
  );
};
